import { Button, Checkbox, Hairline } from "@components";

import styles from "@styles/home-configurations.module.scss";

import classNames from "classnames/bind";
import { useEffect, useRef, useState } from "react";
import { If } from "shared/components/control-statements";
import { useDragScroll } from "shared/hooks/useDragScroll";
const css = classNames.bind(styles);

const BannersSection = ({
  section,
  onChange,
  onSelect,
  onSelectItem,
  onDrop,
  dropdown,
  onAddItems,
  sorting,
  onSortItems,
  onDelete,
  sortingItems,
  onCancelSorting,
  collapsedSection,
}) => {
  const [collapsed, setCollapsed] = useState(sortingItems || false);

  useEffect(() => {
    if (section.id === collapsedSection) setCollapsed(true);
  }, [section, collapsedSection]);

  const itemsRef = useRef(null);

  useEffect(() => {
    if (!itemsRef.current) itemsRef.current = section.items;
  }, [section.items]);

  const moveItem = (index, direction) => {
    const newIndex = index + direction;

    if (newIndex < 0 || newIndex >= (section.items || []).length) return;

    const newItems = [...section.items];
    const temp = newItems[index];
    newItems[index] = newItems[newIndex];
    newItems[newIndex] = temp;

    onChange({ ...section, items: newItems });
  };

  const { scrollRef, onMouseDown, wasDragging } = useDragScroll();

  return (
    <div
      className={css({
        section: true,
        collapsed: collapsed,
      })}
      onClick={() => {
        if (wasDragging()) return;
        setCollapsed(!collapsed);
      }}
      key={section.id}
    >
      <div className="d-flex align-center justify-between w-100">
        <div className="d-flex align-center gap-20 w-100">
          <If cond={!sorting && !sortingItems}>
            <Checkbox
              checked={section.active}
              value={true}
              onChange={() => {
                onChange({
                  ...section,
                  active: !section.active,
                });
              }}
              disabled={!section.items || section.items.length === 0}
            />
          </If>
          <div className="d-flex align-center justify-between w-100">
            <div className="d-flex flex-column">
              <If cond={section.layout !== "FULL_SCREEN"}>
                <p className={styles.title}>{section.title}</p>
              </If>
              <If cond={section.layout === "FULL_SCREEN"}>
                <p className={styles.title}>Seção de banners de tela cheia</p>
              </If>
              <span className={styles.type}>Seção de banners</span>
            </div>
            <If cond={sortingItems}>
              <div className="d-flex align-center">
                <Button
                  design="primary"
                  className="mr-10"
                  onClick={onCancelSorting}
                >
                  Salvar ordenação
                </Button>
                <Button
                  onClick={() => {
                    onChange({ ...section, items: itemsRef.current });
                    onCancelSorting();
                  }}
                >
                  Cancelar
                </Button>
              </div>
            </If>
          </div>
        </div>

        <If cond={!sorting && !sortingItems}>
          <div className="d-flex align-center">
            <div
              className={styles.dropdown}
              onClick={(e) => {
                onDrop(dropdown === section.id ? null : section.id);
                e.stopPropagation();
              }}
            >
              <div className={styles.action}>
                <i className="fal fa-ellipsis-v" />
              </div>

              <div
                className={css({
                  dropdownOptions: true,
                  in: dropdown === section.id,
                  out: dropdown !== section.id,
                })}
              >
                <ul className={styles.options}>
                  <li onClick={() => onSelect(section)}>Editar</li>
                  <If cond={(section.items || []).length > 0}>
                    <li onClick={() => onSortItems(section)}>Ordenar itens</li>
                  </If>
                  <li onClick={() => onDelete(section)}>Excluir</li>
                </ul>
              </div>
            </div>
            <div className={styles.hairline} />
            <div className={styles.collapse}>
              {collapsed ? (
                <i className="far fa-chevron-up" />
              ) : (
                <i className="far fa-chevron-down" />
              )}
            </div>
          </div>
        </If>
      </div>

      <If cond={collapsed || sortingItems}>
        <If cond={(section.items || []).length > 0}>
          <Hairline className="mt-15 mb-0" />
          <div
            className={styles.bannersItems}
            style={{ flexDirection: sortingItems ? "column" : "row" }}
            onMouseDown={onMouseDown}
            ref={scrollRef}
          >
            {(section.items || []).map((banner, index) => {
              return (
                <>
                  <div
                    className={styles.banner}
                    key={banner.id}
                    onClick={(e) => e.stopPropagation()}
                    style={{ width: sortingItems ? "100%" : "" }}
                  >
                    <div className="d-flex align-center">
                      <div className={styles.image}>
                        <img
                          src={
                            process.env.REACT_APP_ASSETS_URL +
                            `/` +
                            banner.mobile
                          }
                          alt=""
                        />
                      </div>
                      <If cond={banner.link}>
                        <div className={styles.link}>
                          <i className="far fa-link" />
                        </div>
                      </If>
                      <If cond={!sortingItems}>
                        <div className={styles.edit}>
                          <Button onClick={() => onSelectItem(section, banner)}>
                            Editar imagem
                          </Button>
                        </div>
                      </If>
                    </div>

                    <If cond={sortingItems}>
                      <div className="d-flex align-center gap-10">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            moveItem(index, 1);
                          }}
                          disabled={index === section?.items.length - 1}
                          type="button"
                          className={styles.moveDown}
                        >
                          <i className="fas fa-chevron-down" />
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            moveItem(index, -1);
                          }}
                          disabled={index === 0}
                          type="button"
                          className={styles.moveUp}
                        >
                          <i className="fas fa-chevron-up" />
                        </button>
                      </div>
                    </If>
                  </div>

                  <If
                    cond={
                      index < (section.items || []).length - 1 && sortingItems
                    }
                  >
                    <Hairline className="mt-5 mb-5" />
                  </If>
                </>
              );
            })}
          </div>
        </If>

        <If cond={!sortingItems}>
          <div className={styles.addContainer}>
            <If cond={!section.items || section.items.length === 0}>
              <p>Não existem banners adicionados à esta seção</p>
            </If>
            <Button design="withIcon" onClick={() => onAddItems(section)}>
              <i className="far fa-plus" /> Adicionar{" "}
              {(section.items || [])?.length > 0 ? "banner" : "banners"}
            </Button>
          </div>
        </If>
      </If>
    </div>
  );
};

export default BannersSection;
